export const NUNITO = '"Nunito", sans-serif';
export const MONTSERRAT = '"Montserrat", sans-serif'
export const SEGOEUI = '"SegoeUI",sans-serif'
export const OPENSANS = '"Open Sans",sans-serif'
